import React from 'react';
import Button from '../../components/uielements/button';
import logo from '../../image/Caminos_logo.png';

const styles = {
  page: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f7fb',
    padding: 24
  },
  content: {
    maxWidth: 560,
    width: '100%',
    textAlign: 'center',
    color: '#232b3a'
  },
  logo: {
    width: 'min(280px, 70vw)',
    marginBottom: 32
  },
  title: {
    margin: '0 0 16px',
    fontSize: 34,
    lineHeight: 1.2,
    fontWeight: 600
  },
  message: {
    margin: '0 0 28px',
    fontSize: 17,
    lineHeight: 1.6,
    color: '#536171'
  }
};

const MaintenancePage = ({ onRetry, retrying }) => (
  <main style={styles.page}>
    <section style={styles.content}>
      <img src={logo} style={styles.logo} alt="CAMINOS DE LAS SIERRAS" />
      <h1 style={styles.title}>Sitio en mantenimiento</h1>
      <p style={styles.message}>
        Estamos realizando tareas de mantenimiento. Por favor, volvé a intentar
        más tarde.
      </p>
      <Button type="primary" size="large" loading={retrying} onClick={onRetry}>
        Reintentar
      </Button>
    </section>
  </main>
);

export default MaintenancePage;
